import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-menu-set" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "app-section" }

import { onMounted, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { useMarketCartStore } from '@/stores/cart.store';
    import { storeToRefs } from 'pinia';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FrontOfficeMarketLayout',
  setup(__props) {

    const router = useRouter();
    const cartStore = useMarketCartStore();
    const { getTotalItems } = storeToRefs(cartStore);
    const sidebarOpen = ref(true);
    const routes = ref([
        { id: 'market-portail', name: 'Portail', path: '/front/market/portail', icon: '/public/icons/icon-profil.svg', initialSidebarOpen: false },
        { id: 'market-produits', name: 'Produits', path: '/front/market/produits', icon: '/public/icons/icon-menu-securite.svg', initialSidebarOpen: false },
        { id: 'market-commandes', name: 'Mes commandes', path: '/front/market/commandes', icon: '/public/icons/icon-idcard-recto.svg', initialSidebarOpen: true },
        { id: 'market-panier', name: `Panier (${cartStore.getTotalItems})`, path: '/front/market/panier', icon: '/public/icons/icon-info-perso.svg', initialSidebarOpen: true },
    ]);
    const activeRoute = ref(router.currentRoute.value.path);

    onMounted(() => {
        router.afterEach((to) => {
            activeRoute.value = to.path;
            updateSidebarStateBasedOnRoute(to.path);
        });
        updateSidebarStateBasedOnRoute(router.currentRoute.value.path);
        cartStore._fetchCart();
    });

    function updateSidebarStateBasedOnRoute(path: string) {
        const matchingRoute = routes.value.find(route => route.path === path);
        if (matchingRoute) {
            sidebarOpen.value = matchingRoute.initialSidebarOpen;
        }
    }

    watch(getTotalItems, (newValue, oldValue) => {
        const cartRouteIndex = routes.value.findIndex(r => r.id == 'market-panier');
        if (cartRouteIndex > -1) {
            routes.value[cartRouteIndex].name = `Panier (${newValue})`
            routes.value = [...routes.value];
        }
    });

    function toggleSidebar() {
        sidebarOpen.value = !sidebarOpen.value
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(['sidebar', { close: !sidebarOpen.value }])
    }, [
      _createElementVNode("div", {
        class: "sidebar-icon",
        onClick: toggleSidebar
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createElementVNode("div", {
        class: "sidebar-icon close",
        onClick: toggleSidebar
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: route.path,
            key: route.path
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['sidebar-menu-animate', { active: activeRoute.value == route.path }])
              }, [
                _createElementVNode("li", {
                  class: _normalizeClass(['sidebar-menu', { active: activeRoute.value == route.path }])
                }, [
                  _createElementVNode("img", {
                    src: route.icon,
                    class: "sidebar-menu-icon",
                    alt: ""
                  }, null, 8, _hoisted_2),
                  _createElementVNode("span", null, _toDisplayString(route.name), 1)
                ], 2)
              ], 2)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ], 2),
    _createElementVNode("section", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-space-25" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})